import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { Clock, Loader2 } from "lucide-react";

const OPTIONS = [14, 7, 3, 1, 0];

export default function ExpiryAlertsCard() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/expiry-alerts").then(({ data }) => setS(data)).catch(() => {}); }, []);
  const save = async (next) => {
    setS(next);
    try { const { data } = await api.put("/settings/expiry-alerts", next); setS(data); toast.success("Notifiche scadenze aggiornate"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const runNow = async () => {
    setBusy(true);
    try { const { data } = await api.post("/haccp/expiry-alerts/run"); toast.success(`Controllo eseguito: ${data.alerts} lotti segnalati`); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!s) return null;
  return (
    <Card className="p-6 rounded-xl max-w-2xl mb-6" data-testid="expiry-alerts-card">
      <div className="flex items-center gap-2 mb-2 text-primary"><Clock className="w-5 h-5" /><h3 className="font-dash font-semibold text-lg">Notifiche scadenze HACCP</h3></div>
      <p className="text-sm text-muted-foreground mb-4">Ogni giorno alle 07:00 il sistema controlla i lotti in magazzino e segnala quelli in scadenza nella Dashboard e via email al titolare.</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {OPTIONS.map((d) => {
          const on = s.days.includes(d);
          return <button key={d} type="button" onClick={() => save({ ...s, days: on ? s.days.filter((x) => x !== d) : [...s.days, d] })} className={`text-sm px-3 py-1 rounded-full border transition-colors ${on ? "bg-primary text-primary-foreground border-primary" : "bg-secondary text-muted-foreground border-transparent"}`} data-testid={`expiry-day-${d}`}>{d === 0 ? "Scadenza oggi" : `${d} giorni prima`}</button>;
        })}
        <span className="text-xs text-muted-foreground self-center">+ sempre i lotti scaduti</span>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-2 text-sm"><Switch checked={s.email} onCheckedChange={(v) => save({ ...s, email: v })} data-testid="expiry-email-switch" /><Label>Email al titolare</Label></label>
        <Button size="sm" variant="outline" className="rounded-full" onClick={runNow} disabled={busy} data-testid="expiry-run-now">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Esegui controllo ora"}</Button>
      </div>
    </Card>
  );
}
